export const normalizeStatusName = (value?: string | null): string =>
  (value ?? "").trim().toLowerCase();

export const isSameStatus = (
  a?: string | null,
  b?: string | null,
): boolean => normalizeStatusName(a) === normalizeStatusName(b);
